<div class="max-w-full mx-auto">
  <div>
    <button [routerLink]="'/home/biller'"
      class="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 mx-3 mb-7 rounded">Enviar proceso a
      un proveedor
    </button>
    <button [routerLink]="'/home/billing'"
      class="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 mx-3 mb-7 rounded">Enviar proceso a
      todos los proveedores
    </button>
  </div>
  <h2 class="text-3xl font-semibold text-center text-gray-800 mb-3 uppercase">Procesos de Facturación</h2>
  <div class="overflow-auto rounded-lg rounded-b-none shadow-lg">
    <table class="w-full leading-normal">
      <thead class="bg-orange-500 text-white">
        <tr>
          <th class="px-5 py-3 border-b-2 border-orange-600">ID</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Fecha</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Estado</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Proveedores Totales</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Proveedores Fallidos</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Proveedores Enviados</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Fecha de Inicio</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Fecha de Fin</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Proveedores</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Filtros</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Más Detalles</th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr *ngFor="let process of billingProcesses; even as isEven"
          class="hover:bg-gray-200 transition duration-150 ease-in-out">
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ process.OrderId }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ process.date || '-' }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">
            <ng-container *ngIf="process.status === 'pending'; else statusFinished">
              <mat-spinner [diameter]="40" strokeWidth="4"></mat-spinner>
            </ng-container>
            <ng-template #statusFinished>
              <ng-container *ngIf="process.status === 'finished'; else statusCanceled">
                <i class="fa-solid fa-check"></i>
              </ng-container>
            </ng-template>
            <ng-template #statusCanceled>
              <ng-container *ngIf="process.status === 'canceled'">
                <i class="fa-solid fa-exclamation"></i> </ng-container>
            </ng-template>
          </td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ process.totalProviders || '-' }}
          </td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{
            getDisplayValue(process.failedProvidersAmount) }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{
            getDisplayValue(process.sentProvidersAmount) }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ process.billingStartDate || '-' }}
          </td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ process.billingEndDate || '-' }}
          </td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">
            <!-- <span *ngFor="let provider of process.providers">{{ provider.name || '-' }}</span> -->
            {{ getProvidersNames(process.providers) }}
          </td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">
            <span *ngFor="let filter of process.filters">{{ filter }}</span>
          </td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">
            <button mat-raised-button (click)="showBillingProcessDetails(process)" matTooltip="Ver detalles del proceso"
              aria-label="Ver detalles del proceso" class="details-button orange">
              <mat-icon>visibility</mat-icon> Detalles
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="billingProcesses.length === 0 && !isLoading" class="bg-white shadow-md rounded-lg mt-5 p-7">
    <h1 class="text-2xl font-bold text-center text-gray-600">No se encontraron procesos de facturación.</h1>
  </div>

  <ng-container *ngIf="billingProcesses.length > 0">
    <div class="relative mb-5">
      <mat-paginator [length]="totalItems" hidePageSize="true" [pageSize]="itemsPerPage"
        [pageSizeOptions]="pageSizeOptions" (page)="handlePageEvent($event)">
      </mat-paginator>
    </div>
  </ng-container>

  <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white opacity-75">
    <mat-spinner class="text-orange-500 animate-spin" strokeWidth="3" [diameter]="70"></mat-spinner>
  </div>
</div>